module.exports = __webpack_public_path__ + "images/record.gif";